import(/* webpackMode: "eager" */ "/app/app/results/page.tsx");
